const isProd = process.env.NODE_ENV === 'production'
const localServiceContent = process.env['serviceContent.apiBaseUrl']

export default {
  origin: localServiceContent || `https://service-content.${isProd ? 'production' : 'non-production'}.internal.zmarta.org`
}
